import { useCallback } from 'react';
import { ClientRegistrationState } from '@common/model/client/registration/registrationState';
import { LayoutConfig, useModal } from '@cp/shared/modal';
import { REGISTRATION_MODAL } from '../lib';
import { RegistrationStep } from './step';

export const useRegistrationModal = () => {
  const { openModal } = useModal();
  return useCallback(
    (step: RegistrationStep, layout?: LayoutConfig) => {
      return new Promise<Partial<ClientRegistrationState>>((resolve, reject) => {
        openModal(
          REGISTRATION_MODAL,
          { step, onFailure: reject, onCancel: reject, onSuccess: (state) => resolve(state) },
          undefined,
          layout,
        );
      });
    },
    [openModal],
  );
};
